export default {
    h1: "32px",
    h2: "28px",
    h3: "26px",
    h4: "24px",
    h5: "20px",
    h6: "18px",
    p: "16px",
    ps: "14px",
}
